export enum FredhopperSegment {
  A = 'a',
  B = 'b',
}
